/**
 * CITY_ROWS — every configured metro with its per-city hue accent
 * (contained to metro pickers/pills; the app body stays pure-trio).
 * Extracted from MetroPickerPage when the /metro route was retired
 * (plan R2-5, 2026-07-07) — the home hero's metro pills are the gate now.
 */
export const CITY_ROWS: Array<{
  key: string;
  emoji: string;
  tagline: string;
  accent: string; // per-city hue, contained to the metro pickers
  glow: string;
  /** Shown in the offline fallback (metros API not loaded / failed). The live
   *  picker ignores this and shows whatever /api/public/metros reports active,
   *  so launching a metro is the backend `active` flag; flip this too so the
   *  fallback matches. */
  launched: boolean;
}> = [
  { key: 'Austin', emoji: '🎸', tagline: 'Live Music Capital of the World', accent: '#FFD24D', glow: 'rgba(255, 200, 60, 0.35)', launched: true },
  { key: 'Dallas', emoji: '🤠', tagline: 'Big D, big options', accent: '#B98CFF', glow: 'rgba(185, 140, 255, 0.3)', launched: true },
  { key: 'Houston', emoji: '🚀', tagline: 'Space City, space for you', accent: '#35E0C8', glow: 'rgba(53, 224, 200, 0.3)', launched: true },
  { key: 'San Antonio', emoji: '🌮', tagline: 'Big-city energy, small-town welcome', accent: '#FF7A59', glow: 'rgba(255, 122, 89, 0.3)', launched: true },
];

/** T12 — the hero submits with zero interaction, so a metro is always
 *  selected. Austin is the default (largest inventory, the launch market);
 *  the pills stay as a one-tap override. */
export const DEFAULT_METRO = 'Austin';

/** Label shared by the hero pills and the header city menu. */
export function metroMenuLabel(key: string): string {
  return key === 'Dallas' ? 'Dallas / Fort Worth' : key;
}

/** 'san-antonio' or 'San Antonio' → the registry key, or null. */
export function metroFromPathSlug(slug: string): string | null {
  const norm = slug.trim().toLowerCase().replace(/[\s_]+/g, '-');
  const row = CITY_ROWS.find((city) => city.key.toLowerCase().replace(/\s+/g, '-') === norm);
  return row?.key ?? null;
}

/**
 * The one city list. Before /api/public/metros lands in the store, launched
 * rows are the list. After it lands, a metro the API marks inactive drops
 * out of both the hero and the header.
 */
export function visibleMetroOptions(
  metros: Array<{ key: string }> | null | undefined,
): Array<{ key: string; label: string }> {
  const activeKeys = new Set((metros || []).map((metro) => metro.key));
  const rows = CITY_ROWS.filter((city) => (activeKeys.size === 0 ? city.launched : activeKeys.has(city.key)));
  return rows.map((city) => ({ key: city.key, label: metroMenuLabel(city.key) }));
}

